const namespace = "sdsApp";

import AppConfig from "@/_config/application-config"
import childRoutes from "./routes"
import BrowserStorage from "@/_util/storage-modes.browser-storage";

const localStorage = new BrowserStorage(namespace);
const sessionStorage = new BrowserStorage(namespace, true);

const appConfig = {
  // "namespace" : {
  name: "Supplied SDS Lookup Portal",
  namespace,
  description: null,
  version: "0.1.0",
  icon: "mdi-gauge",
  accentColor: "#000080",
  mainNavEnabled: false,
  parentRoute: "/sds",
  defaultRoute: "home",
  topBarEnabled: false,
  childRoutes,
  component : () => import(/* webpackChunkName: "custom-left-nav" */ "@/apps/sds/Application.vue"),
  //Global Nav
  
  settings: {
    environment : "DEV",
    clientId: "65696c3b-cf0a-481c-bec6-a900531206ad",
    apiUrl: "https://api.nonprd.lyb.com/external/v1/SDSAPI",
    apiUrlChems:"https://api.nonprd.lyb.com/external/dev/chemsdb/v1/api/SDS",
    scope: "api://65696c3b-cf0a-481c-bec6-a900531206ad/Read.All",
    authorizeUrl: "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/authorize",
    tokenUrl: "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/token",
    logoutUrl: `https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri=${window.location.origin}`,
    redirect_uri: window.location.origin,
    env_color_dev: { "r": 96, "g": 125, "b": 139, "a": 1 }, 
    env_color_stg: { "r": 38, "g": 166, "b": 154, "a": 1 },
  }, 
  store: {
    pageTitle: {
      default: "Supplied SDS Lookup Portal",
      storageMode: localStorage,
    },
    userDetails: {
      default: {},
      storageMode: sessionStorage,
    },
  },

}

export default AppConfig.merge(appConfig);


